import React from 'react'
import {
  Control,
  FieldValues,
  UseFormGetValues,
  UseFormWatch,
} from 'react-hook-form'

import s from './styles.module.scss'

import { MinMaxInputFields } from '../../../atoms/min-max-input-fields/MinMaxInputFields'

interface IHouseSearchFilterSearchProps<T extends FieldValues> {
  control: Control<T, any>
  minName: string
  maxName: string
  title?: React.ReactNode
  getValues: UseFormGetValues<T>
  watch: UseFormWatch<T>
}

export const HouseSearchFilterNumberOfBedrooms = <T extends FieldValues>({
  control,
  minName,
  maxName,
  title,
  getValues,
  watch,
}: IHouseSearchFilterSearchProps<T>) => {
  return (
    <div className={s.container}>
      {title}
      <MinMaxInputFields
        control={control}
        minName={minName}
        maxName={maxName}
        minLimit={1}
        maxLimit={100_000}
        getValues={getValues}
        watch={watch}
      />
    </div>
  )
}
